import * as React from "react";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import { ReactComponent as Tjommie } from "../Resources/Tjommie.svg";
import { ReactComponent as Whatsapp } from "../Resources/Whatsapp.svg";
import { ReactComponent as WhatsappCTA } from "../Resources/WhatsappCTA.svg";
import ClearIcon from "@mui/icons-material/Clear";
import Button from "@mui/material/Button";
export default function WhatsappPage() {
  let { serial_number } = useParams();
  const navigate = useNavigate();

  const goToNext = () => {
    navigate(`/residents/${serial_number}/add-to-home`);
  };
  const goToPrevious = () => {
    navigate(`/residents/${serial_number}/hot-water-index`);
  };
  const skipOnboarding = () => {
    if (onboardingCompleted == "true") {
      navigate(`/residents/${serial_number}/support`);
    } else {
      navigate(`/residents/${serial_number}/terms-and-conditions`);
    }
  };

  const onboardingCompleted = localStorage.getItem("onboardingCompleted");

  React.useEffect(() => {
    if (onboardingCompleted) {
    }
  }, []);
  return (
    <Box bgcolor="#636569" minHeight="100vh">
        <Grid
        container
        alignItems="center"
        justifyContent="center"
        bgcolor="#636569"
        height="5vh"
        
      >
        <Grid item xs={11} align="center">
          <Grid container>
            <Grid item xs={2} align="left" sx={{ mt: 2 }}>
              <ClearIcon sx={{ color: "white" }} onClick={skipOnboarding} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        bgcolor="#636569"
        height="5vh"
       
      />

      <Grid
        container
        alignItems="center"
        justifyContent="center"
        bgcolor="#636569"
        height="5vh"
       
      >
        <Grid item xs={12} sx={{ mt: 2, mb: 14 }} align="center">
          <Tjommie width="45%" />
        </Grid>
      </Grid>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        bgcolor="#636569"
        height="4vh"
      />
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        bgcolor="#636569"
        height="57vh"
      >
        <Grid item xs={11} align="center">
         
            <Grid container>
           
              <Grid item xs={9} align="left">
                <Typography
                  variant="h5"
                  sx={{ color: "#fff", fontSize: "30px", textAlign: "left" , ml: 1}}
                >
                  {" "}
                  WE'RE ON WHATSAPP
                </Typography>
              </Grid>

              <Grid item xs={3} align="left">
                <Whatsapp />
              </Grid>
              <Grid item xs={0.5} />

              <Grid item xs={11} sx={{ mt: 2 }} align="center">
                <ParagraphedText />
              </Grid>
              <Grid item xs={10} align="left">
                <TjommieSupport />
              </Grid>
  
            </Grid>
         
        </Grid>
      </Grid>

      <Grid
        container
        alignItems="center"
        justifyContent="center"
        bgcolor="#636569"
        height="10vh"
      >
         <Grid item xs={5} align="left">
                
                <Button
                  fullWidth
                  onClick={goToPrevious}
                  style={{ color: "#FDB940" }}
                >
                  Previous
                </Button>
                
              </Grid>
              <Grid item xs={6} align="left">
                <Button
                  fullWidth
                  onClick={goToNext}
                  style={{ color: "#000", backgroundColor: "#FDB940" }}
                >
                  Next
                </Button>
              </Grid>
      </Grid>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        bgcolor="#636569"
        height="5vh"
      />
    </Box>
  );
}

function ParagraphedText() {
  return (
    <>
      <p style={{ fontSize: "20px", color: "white", textAlign: "left" }}>
        We are available for support!
        <br />
      </p>
      <p style={{ fontSize: "14px", color: "white", textAlign: "left" }}>
        Add us on whats app and shoot us a message for any questions or
        complaints. Let us know how the installation went, or share your
        thoughts on the project..
      </p>
    </>
  );
}

function TjommieSupport() {
  return (
    <>

       
        
            <WhatsappCTA  style={{ width: '120%' }}  />
       
  
    </>
  );
}
